<template>
  <div class="dongji" id="dongji">
    <!-- ps img -->
    <div class="con-imgs-box">
      <img
        class="con-img"
        v-for="(item,index) in 31"
        :src="getConImgUrl(item)"
        :key="index"
        @click="imgClick(index)"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "dongji",
  data() {
    return {
      msg: "dongji page"
    };
  },
  methods: {
    getConImgUrl(item) {
      return require("../assets/img/dongji/dongji_ps_" +
        (item > 9 ? item + "" : "0" + item) +
        ".jpg");
    },
    imgClick(index){
      if(index===3||index===6||index===30){
        // doyoo.util.openChat('c=20001028&f=10055590&n=10058677');
        window.open('http://chat.looyuoms.com/chat/chat/p.do?c=20001028&f=10055590&g=10058680');
      }
      return false;
    }
  }
};
</script>
<style lang="less" scoped>
.con-imgs-box {
  .con-img {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
  }
}
</style>

